function initBfsProducts(scope = document) {
  scope.querySelectorAll('[data-bfs-product]').forEach(root => {
    if (root.dataset.initialized) return;
    const select = root.querySelector('[data-product-variant]');
    if (!select) return;
    root.dataset.initialized = 'true';
    const variants = [...select.options].map(option => ({option, id: option.value, choices: JSON.parse(option.dataset.options || '[]')}));
    const radios = [...root.querySelectorAll('[data-option-index]')];
    const picker = root.querySelector('[data-option-picker]');
    const medias = [...root.querySelectorAll('.bfs-product-media[data-media-id]')];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const zoomDialog = root.querySelector('[data-zoom-dialog]');
    const zoomLinks = [...root.querySelectorAll('[data-product-zoom]')];
    if (zoomDialog && typeof zoomDialog.showModal === 'function') {
      const zoomImage = zoomDialog.querySelector('img');
      let zoomIndex = 0;
      function showZoom(index) {
        zoomIndex = (index + zoomLinks.length) % zoomLinks.length;
        const link = zoomLinks[zoomIndex];
        const image = link.querySelector('img');
        zoomImage.removeAttribute('srcset');
        zoomImage.removeAttribute('sizes');
        zoomImage.src = link.href;
        zoomImage.alt = image?.alt || '';
        zoomDialog.querySelector('[data-zoom-count]').textContent = `${zoomIndex + 1} / ${zoomLinks.length}`;
      }
      zoomLinks.forEach((link, index) => link.addEventListener('click', event => {
        event.preventDefault();
        showZoom(index);
        zoomDialog.showModal();
      }));
      zoomDialog.querySelector('[data-zoom-close]').addEventListener('click', () => zoomDialog.close());
      const previous = zoomDialog.querySelector('[data-zoom-prev]');
      const next = zoomDialog.querySelector('[data-zoom-next]');
      previous.disabled = next.disabled = zoomLinks.length < 2;
      previous.addEventListener('click', () => showZoom(zoomIndex - 1));
      next.addEventListener('click', () => showZoom(zoomIndex + 1));
      zoomDialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {event.preventDefault(); showZoom(zoomIndex - 1);}
        if (event.key === 'ArrowRight') {event.preventDefault(); showZoom(zoomIndex + 1);}
      });
      zoomDialog.addEventListener('click', event => {
        if (event.target === zoomDialog) {
          const bounds = zoomDialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) zoomDialog.close();
        }
      });
    }
    function showMedia(id) {
      const chosen = medias.find(media => media.dataset.mediaId === id);
      if (!chosen) return;
      medias.forEach(media => {
        media.classList.toggle('is-active', media === chosen);
        if (media !== chosen) {
          media.querySelectorAll('video').forEach(video => video.pause());
          media.querySelectorAll('iframe').forEach(frame => {
            if (media.classList.contains('was-active')) frame.src = frame.src;
          });
        }
        media.classList.toggle('was-active', media === chosen);
      });
      thumbs.forEach(thumb => thumb.setAttribute('aria-current', String(thumb.dataset.galleryThumb === id)));
      const count = root.querySelector('[data-gallery-count]');
      if (count) count.textContent = `${medias.indexOf(chosen) + 1} / ${medias.length}`;
    }
    thumbs.forEach(thumb => thumb.addEventListener('click', event => {event.preventDefault(); showMedia(thumb.dataset.galleryThumb);}));
    function moveGallery(direction) {
      const active = medias.findIndex(media => media.classList.contains('is-active'));
      const next = medias[(active + direction + medias.length) % medias.length];
      if (next) showMedia(next.dataset.mediaId);
    }
    const controls = root.querySelector('[data-gallery-controls]');
    if (controls) {
      controls.hidden = false;
      root.querySelector('[data-gallery-prev]').addEventListener('click', () => moveGallery(-1));
      root.querySelector('[data-gallery-next]').addEventListener('click', () => moveGallery(1));
      root.querySelector('[data-gallery-stage]').addEventListener('keydown', event => {
        if (event.target.closest('video, iframe, model-viewer')) return;
        if (event.key === 'ArrowLeft') {event.preventDefault(); moveGallery(-1);}
        if (event.key === 'ArrowRight') {event.preventDefault(); moveGallery(1);}
      });
    }
    function selectedChoices() {
      const choices = [];
      radios.filter(radio => radio.checked).forEach(radio => {choices[Number(radio.dataset.optionIndex)] = radio.value;});
      return choices;
    }
    function update(option, changeMedia = true) {
      const available = option?.dataset.available === 'true';
      const button = root.querySelector('[data-product-add]');
      button.disabled = !available;
      button.textContent = available ? root.dataset.addLabel : option ? root.dataset.soldLabel : root.dataset.unavailableLabel;
      root.querySelector('[data-product-status]').textContent = available ? root.dataset.availableLabel : option ? root.dataset.soldLabel : root.dataset.unavailableLabel;
      const compare = root.querySelector('[data-product-compare]');
      if (option) root.querySelector('[data-product-price]').textContent = option.dataset.price;
      compare.textContent = option?.dataset.compare || '';
      compare.hidden = !option?.dataset.compare;
      const checkout = root.querySelector('[data-product-checkout]');
      if (checkout) checkout.hidden = !available;
      root.querySelector('[data-product-sku]').textContent = option?.dataset.sku || '';
      root.querySelector('[data-product-sku-wrap]').hidden = !option?.dataset.sku;
      const quantity = root.querySelector('[data-product-quantity]');
      quantity.min = option?.dataset.min || '1';
      quantity.step = option?.dataset.step || '1';
      if (option?.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      if (!quantity.checkValidity()) quantity.value = quantity.min;
      if (option) {
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
        if (changeMedia && option.dataset.mediaId) showMedia(option.dataset.mediaId);
      }
      const choices = selectedChoices();
      radios.forEach(radio => {
        const index = Number(radio.dataset.optionIndex);
        const matching = variants.filter(variant => variant.choices.every((value, position) => value === (position === index ? radio.value : choices[position])));
        const sold = matching.length > 0 && matching.every(variant => variant.option.dataset.available !== 'true');
        const impossible = matching.length === 0;
        radio.closest('label').classList.toggle('is-unavailable', sold || impossible);
        radio.closest('label').querySelector('small').textContent = sold ? root.dataset.soldLabel : impossible ? root.dataset.unavailableLabel : '';
      });
      choices.forEach((value, index) => {const label = root.querySelector(`[data-option-value="${index}"]`); if (label) label.textContent = value;});
    }
    radios.forEach(radio => radio.addEventListener('change', () => {
      const choices = selectedChoices();
      const variant = variants.find(candidate => candidate.choices.every((value, index) => choices[index] === value));
      select.value = variant?.id || '';
      select.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (option) {
        const choices = JSON.parse(option.dataset.options || '[]');
        radios.forEach(radio => {radio.checked = choices[Number(radio.dataset.optionIndex)] === radio.value;});
      }
      update(option);
    });
    root.querySelector('form').addEventListener('submit', event => {
      if (!select.value || select.selectedOptions[0]?.dataset.available !== 'true') event.preventDefault();
    });
    root.classList.add('is-enhanced');
    if (picker) picker.hidden = false;
    update(select.selectedOptions[0]);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initBfsProducts());
else initBfsProducts();
document.addEventListener('shopify:section:load', event => initBfsProducts(event.target));
